import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c60148f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "restore" }
const _hoisted_2 = { class: "restore-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "cloud" }),
  /*#__PURE__*/_createElementVNode("i", { class: "warn" })
], -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 内置磁盘存储空间不足，请先清理内置磁盘空间后，再尝试恢复数据。 ", -1))
const _hoisted_6 = { class: "btns" }



export default /*#__PURE__*/_defineComponent({
  props: {
    close: null,
    isMobile: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  close: () => void
  isMobile?:boolean
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h2", null, _toDisplayString(props.isMobile ? '暂无法恢复数据' : '从云备份空间恢复数据'), 1),
      _createElementVNode("i", {
        class: "icomoon-close head-close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.close && props.close(...args)))
      })
    ]),
    (!props.isMobile)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 暂无法恢复数据 "))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (props.close && props.close(...args)))
      }, "知道了")
    ])
  ]))
}
}

})